import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '../stores/auth';

const routes = [
  { path: '/campaigns/new', component: () => import('../views/CampaignEditorView.vue'), meta: { requiresAuth: true, allowedRoles: ['admin', 'superadmin'] } },
  { path: '/campaigns/:id/edit', component: () => import('../views/CampaignEditorView.vue'), meta: { requiresAuth: true, allowedRoles: ['admin', 'superadmin'] } },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/LoginView.vue'),
    meta: { guest: true },
  },
  {
    path: '/',
    name: 'Dashboard',
    component: () => import('../views/DashboardView.vue'),
    meta: { requiresAuth: true, allowedRoles: ['officer', 'admin', 'superadmin'] },
  },
  {
    path: '/shops',
    name: 'Shops',
    component: () => import('../views/ShopsView.vue'),
    meta: { requiresAuth: true, allowedRoles: ['superadmin'], developerOnly: true },
  },
  {
    path: '/members',
    name: 'Members',
    component: () => import('../views/MembersView.vue'),
    meta: { requiresAuth: true, allowedRoles: ['officer', 'admin', 'superadmin'] },
  },
  {
    path: '/members/:id',
    name: 'MemberDetail',
    component: () => import('../views/MemberDetailView.vue'),
    meta: { requiresAuth: true, allowedRoles: ['officer', 'admin', 'superadmin'] },
  },
  {
    path: '/campaigns',
    name: 'Campaigns',
    component: () => import('../views/CampaignsView.vue'),
    meta: { requiresAuth: true, allowedRoles: ['admin', 'superadmin'] },
  },
  {
    path: '/coupons',
    name: 'Coupons',
    component: () => import('../views/CouponsView.vue'),
    meta: { requiresAuth: true, allowedRoles: ['admin', 'superadmin'] },
  },
  {
    path: '/sync',
    name: 'SyncMonitor',
    component: () => import('../views/SyncMonitorView.vue'),
    meta: { requiresAuth: true, allowedRoles: ['admin', 'superadmin'] },
  },
  { path: '/users', name: 'AdminUsers', component: () => import('../views/AdminUsersView.vue'),
    meta: { requiresAuth: true, allowedRoles: ['superadmin'] } },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const auth = useAuthStore();

  if (to.meta.requiresAuth && !auth.isLoggedIn) {
    return next('/login');
  }
  if (to.meta.guest && auth.isLoggedIn) {
    return next('/');
  }
  if (to.meta.allowedRoles) {
    await auth.fetchMe();
    if (!auth.isLoggedIn) return next('/login');
    if (!to.meta.allowedRoles.includes(auth.user?.role)) return next('/');
    if (to.meta.developerOnly && !auth.user?.is_internal) return next('/');
  }
  next();
});

export default router;
